import { entries } from 'lodash';

export const arrayToKeyValue = (array: any[], key: string): any => {
    const res: any = {};

    array.forEach((row) => {
        res[row[key]] = row;
    });

    return res;
};

export const indexOfObject = <T>(obj: T[], callback: (o: T) => boolean) => {
    let idxOf = -1;

    obj.forEach((val, idx) => {
        if (callback(val)) {
            idxOf = idx;
        }
    });

    return idxOf;
};
